import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function DutchSparkBaseline() {
  return (
    <div className="art-page">
      <SEO
        title="Baseline Study on Pre-Project Fuel Consumption — Dutch Spark"
        description="Between October 2022 and January 2023, CIRCODU collected baseline data across five thematic areas for Dutch Spark, establishing socioeconomic conditions and fuel use patterns to measure future clean cooking intervention impacts."
        keywords="Dutch Spark, baseline study, fuel consumption, socioeconomic, clean cooking intervention, Uganda, pre-project data, household energy use, cooking technologies, sustainable development indicators, CIRCODU, Dutch Spark baseline Uganda, fuel consumption study Uganda, socioeconomic study Uganda, clean cooking impact measurement Uganda, household energy patterns Uganda, sustainable development indicators Uganda"
        url="/Baseline-Study-on-Pre-Project-Fuel-Consumption-Dutch-Spark-for-Clean-Cooking-Solutions"
        datePublished="2023-01-10"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Baseline Study on Pre-Project Fuel Consumption — Dutch Spark for
              Clean Cooking Solutions
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              January 10, 2023
            </div>
            <h1 className="art-title">
              Baseline Study on Pre-Project Fuel Consumption — Dutch Spark for
              Clean Cooking Solutions
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                Between October 2022 and January 2023, CIRCODU conducted a
                pre-project baseline study for{" "}
                <strong>Dutch Spark for Clean Cooking Solutions</strong> across
                multiple regions of Uganda. Dutch Spark is a Netherlands-based
                organisation focused on accelerating access to clean cooking
                technologies in East Africa. The study was designed to establish
                the critical baseline information needed to quantify fuel
                consumption and social conditions in target communities before
                the introduction of Dutch Spark's clean cooking technologies.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                CIRCODU collected comprehensive data across five thematic areas:
              </p>
              <ol>
                <li>Socioeconomic characteristics of target households.</li>
                <li>Fuels currently used for cooking and heating.</li>
                <li>Technologies currently used for cooking and heating.</li>
                <li>
                  Alternative uses of cookstoves beyond primary meal
                  preparation.
                </li>
                <li>
                  Sustainable development indicators relevant to household
                  wellbeing and the surrounding environment.
                </li>
              </ol>
              <p>
                This multi-dimensional baseline profile gave Dutch Spark a
                statistically grounded starting point from which to measure
                future changes in fuel consumption, household expenditure, and
                social outcomes attributable to its clean cooking interventions
                — and the verifiable evidence base needed to support carbon
                crediting and impact reporting.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's baseline study services,
                contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
